import { FC, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import AppSpinner from '../../common/components/AppSpinner';
import { loadNotificationSettings } from '../actions/notification-settings-actions';
import NotificationSettingsSwitcher from '../components/NotificationSettingsSwitcher';
import NotificationsLoadError from '../components/NotificationsLoadError';
import NotificationConfigureStore from '../stores/notification-configure-store';
import NotificationsStore from '../stores/notification-settings-store';

const NotificationSettingsContainer: FC<
  React.PropsWithChildren<NotificationSettingsContainerProps>
> = props => {
  const { isUserAdminRole, orgDisplayName } = props;
  const { notifications, isLoading, errorMessage } =
    useSnapshot(NotificationsStore);

  const { potentialRecipients } = useSnapshot(NotificationConfigureStore);

  useEffect(() => {
    if (notifications.length === 0 && !errorMessage) {
      loadNotificationSettings();
    }
  }, [notifications.length, errorMessage]);

  if (isLoading) {
    return <AppSpinner text='Loading notification settings' />;
  }

  if (errorMessage) {
    return <NotificationsLoadError errorMessage={errorMessage} />;
  }

  return (
    <>
      {notifications.length &&
        notifications.map(n => (
          <NotificationSettingsSwitcher
            notification={n}
            isUserAdminRole={isUserAdminRole}
            potentialRecipients={potentialRecipients}
            orgDisplayName={orgDisplayName}
            key={n.notificationChannelType}
          />
        ))}
    </>
  );
};

export interface NotificationSettingsContainerProps {
  isUserAdminRole: boolean;
  orgDisplayName: string;
}

export default NotificationSettingsContainer;
